import {Module} from "../index";
import TrainingIndex from "./pages/Index.vue";
import messages from "./resources/messages";
import {Coach} from "./entity";
import {CoachFactory} from "@/modules/training/services/SponsorFactory";
import {GameCreationEventSubscriber} from "@/modules/training/subscribers/GameCreationEventSubscriber";
import {TrainingEvaluator} from "@/modules/training/services/TrainingEvaluator";
import {AbstractStaffMemberFactory} from "@/modules/staff/services/factories/AbstractStaffMemberFactory";
import {TYPES as STAFF_TYPES} from "@/modules/staff/types";

export class TrainingModule extends Module {
  messages = messages;

  public entities = [
    Coach,
  ];

  eventSubscribers = [
    GameCreationEventSubscriber,
  ];

  routes = [
    {
      path: '/training',
      name: 'training.index',
      component: TrainingIndex,
    }
  ];

  protected register() {
    super.register();

    this.app.bind<CoachFactory>(CoachFactory).to(CoachFactory);
    this.app.bind<TrainingEvaluator>(TrainingEvaluator).to(TrainingEvaluator);

    this.app.bind<AbstractStaffMemberFactory>(STAFF_TYPES.StaffMemberFactory).to(CoachFactory);
  }

  boot() {
    super.boot();
  }
}
